<template>
  <div :class="['component-container', field.class]" style="font-family: inherit; position: relative;min-width: 100%;">
    <div class="">
        <div v-if="showInput">
          <input 
            type="file"
            :name="name"
            :ref="field.id"
            :id="field.id"
            @change="onFileChange"
            :required="field.required"
            :placeholder="field.placeholder"
            accept="image/*"
            class="form-control"
          />
        </div>
        <label v-if="!showInput" @click.prevent="showInputClick" class="custom-file-label">
          <span class="x3">Adjunta una imagen</span>
          <icon data="clip" /> 
        </label>    
    </div>
    <div v-if="errorMessage" class="owl36_alert owl360_alert-danger">{{ errorMessage }}</div>
    <div v-if="field.msg && !imageUrl" class="helpMessage" style="width: 100%;">
        <p style="text-align: justify; margin: 0;" v-html="field.msg"></p>
    </div>
      <div v-if="imageUrl" class="preview">
        <img :src="imageUrl" class="img-thumbnail" />
      </div>
  </div>
</template>

<script>
export default {
  props: {
    formData: { type: Object },
    formValues: { type: Object },
    field: { type: Object, required: true },
    name: { type: String }
  },
  data() {
    return {
      image: null,
      imageUrl: '',
      errorMessage: '',
      showInput: false
    };
  },
  methods: {
    showInputClick() {
      this.showInput = true;
      this.$nextTick(() => {
        this.$refs[this.field.id].click(); // Disparar automáticamente el clic en el input
      });
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.showInput = false;
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            if (img.width > 1368 || img.height > 768) {
              this.errorMessage = 'Image dimensions should be less than 1368*768 pixels';
              this.image = null;
              this.imageUrl = '';
            } else {
              if (img.height / img.width > 0.6) {
                this.errorMessage = 'La imagen debe ser horizontal, sugerido 1368*768 pixels';
                this.image = null;
                this.imageUrl = '';
              } else {
                this.errorMessage = '';
                this.image = file;
                this.imageUrl = img.src;
                this.$emit('update', { [this.field.id]: file });
              }
            }
          };
        };
        reader.readAsDataURL(file);
      }
    }
  }
};
</script>

<style scoped>
.custom-file-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #007bff;
  font-weight: bold;
  text-decoration: underline;
}

.custom-file-label:hover {
  color: #0056b3;
}

.custom-file-label span {
  margin-right: 8px;
}

.preview {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* Ajusta según el contenedor */
  text-align: center;
}

.preview img {
  max-width: 200px;
  max-height: 200px;
}
</style>
